import Layout from 'components/Layout'
import MainContentContainer from 'components/MainContentContainer'
import Loading from 'components/Loading'
import FormTable from 'components/FormTable/FormTable'
import { useMortgageResult } from 'hooks'

import { mortgagesColumns } from './constants'
import { LoaderContentWrapper, LoaderText, StyledContainer } from './MortgageResult.styles'

const MortgageResult = () => {
  const { onRowClick, error, loading, filteredData } = useMortgageResult()

  if (loading) {
    return (
      <Layout>
        <MainContentContainer pageName="Equity release - Quote Results">
          <LoaderContentWrapper>
            <Loading fontSize={48} />
            <LoaderText>
              Thank you for your patience.
              <br /> We are currently awaiting a response from IRESS
            </LoaderText>
          </LoaderContentWrapper>
        </MainContentContainer>
      </Layout>
    )
  }

  return (
    <Layout>
      <MainContentContainer pageName="Mortgage Results">
        {error ? (
          <p>Please check user input as IRESS return empty response for this user input </p>
        ) : (
          <StyledContainer>
            <FormTable
              columns={mortgagesColumns}
              dataSource={filteredData}
              checkboxColumn={false}
              spacesAroundGrid={false}
              headerGridGap="8px"
              rowHeight={164}
              headerHeight={80}
              onRowClick={onRowClick}
            />
          </StyledContainer>
        )}
        {/* <CustomFooter loading={pdfReportLoading} handlePdfReport={handlePdfReport} handleRequote={handleRequote} disabled={!!error} /> */}
      </MainContentContainer>
    </Layout>
  )
}

export default MortgageResult
